import React from "react";
import { useAppSelector } from "../../../../../hooks/useTypedSelector";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";

export const PackingListCompact = () => {
  const { t } = useTranslation("common");
  const { loading, packingList } = useAppSelector((state) => state.packingList);

  if (loading) {
    return (
      <div className={"spinner-central"}>
        <Spinner size="sm" animation="grow" role="status" variant={"danger"} />
      </div>
    );
  }

  if (!packingList || !packingList.items.length) {
    return <div>{t("No packing list available for this day")}</div>;
  }

  return (
    <div className={"d-flex justify-content-start flex-wrap gap-3"}>
      {packingList.items.map((firstItem) => {
        // The total amount of requests.
        const requestCount = firstItem.items.reduce(
          (sum, secondItem) => sum + (secondItem.requests?.length || 0),
          0,
        );

        // Calculate finalized count for this firstItem
        const finalizedCount = firstItem.items.reduce(
          (sum, secondItem) =>
            sum + (secondItem.requests?.filter((r) => r.finalized).length || 0),
          0,
        );

        // Group all requests by relation, then by state
        const relationMap: Record<
          string,
          {
            name: string;
            states: Record<string, { count: number; finalized: boolean }>;
          }
        > = {};
        firstItem.items.forEach((secondItem) => {
          secondItem.requests?.forEach((request) => {
            const relId = request?.relation?.id ?? "unknown";
            const relName = request?.relation?.name ?? t("Unknown");
            if (!relationMap[relId]) {
              relationMap[relId] = { name: relName, states: {} };
            }
            const state = request.state ?? t("Unknown");
            if (!relationMap[relId].states[state]) {
              relationMap[relId].states[state] = { count: 0, finalized: false };
            }
            relationMap[relId].states[state].count += 1;
            if (request.finalized) {
              relationMap[relId].states[state].finalized = true;
            }
          });
        });

        return (
          <div
            key={firstItem.id}
            className={
              "content" +
              (finalizedCount == requestCount ? " finished-card" : "")
            }
            style={{ width: "400px" }}
          >
            <div className={"content-header d-flex justify-content-between"}>
              <h3>{firstItem.source?.label ?? firstItem.label}</h3>
              <h3>
                {finalizedCount}/{requestCount}
              </h3>
            </div>
            <div className="mt-3">
              {Object.entries(relationMap).map(([relId, rel]) => (
                <div
                  key={relId}
                  className="d-flex mb-2 justify-content-between"
                  style={{ borderTop: "1px solid #ccc", paddingTop: "5px" }}
                >
                  <div className="me-3">
                    <span className={"small"}>{rel.name}:</span>
                  </div>
                  <div className="d-flex flex-column align-items-end">
                    {Object.entries(rel.states).map(([state, stateInfo]) => (
                      <span
                        key={state}
                        className={
                          "mb-1 d-inline-block fw-bold badge bg-" +
                          (stateInfo.finalized ? "success" : "danger")
                        }
                      >
                        {t(state)}: {stateInfo.count}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
